// import { getRequestFormFields } from "../store/FormFields/actions";

// export const InitialState =()=>{
//  const request= getRequestFormFields("requester");
// return request
// }
export const participantsInitialState = [
  {
    id: 1,
    label: "Names",
    name: "names",
    placeholder: "",
    type: "text",
    value: "",
    disabled: false,
  },
  {
    id: 2,
    label: "Category",
    name: "category",
    required: false,
    placeholder: "",
    type: "text",
    value: "",
    disabled: false,
  },
  {
    id: 6,
    label: "Phone Number",
    name: "phoneNo",
    placeholder: "",
    required: false,
    type: "text",
    value: "",
    maxLength: 10,
    minLength: 10,
    disabled: false,
    valid: false,
    validationMessage: "",
  },
  {
    id: 7,
    label: "Email",
    name: "email",
    placeholder: "",
    required: true,
    type: "email",
    value: "",
    disabled: false,
  },
];